import './custome.scss';
import { useContext, useState } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import VideoContext from './store/video-context';
import LoadingOverlay from 'react-loading-overlay';

function App() {
  const vContext = useContext(VideoContext);
  const [isAdmin, setIsAdmin] = useState(vContext.isAdmin);
  // const [isActive, setIsActive] = useState();
  
  function updateAdminType(){
    // console.log('hello');
    setIsAdmin(!isAdmin);
  }
  return (
  // <div style={{height: "100%"}}>

<LoadingOverlay
  active={vContext.isLoaderActive}
  spinner
  text='Loading Please wait ...'
  // styles={{height: "100%"}}
  // styles={{
  //   // spinner: (base) => ({
  //   //   ...base,
  //   //   width: '100px',
  //   //   '& svg circle': {
  //   //     stroke: 'rgba(255, 0, 0, 0.5)'
  //   //   }
  //   // }),
  //   wrapper: (base) => ({
  //     ...base,
  //     // width: '100%',
  //     height: '100vh',    
  // }),
  // }}
  >
    <div className={"App"+ ((vContext.isVideoFullscreen)?' video-full-screen':'')} style={{height: "100vh"}}>
      {vContext.isLoaderActive ? <></>:<Header isAdmin={isAdmin} updateAdmin={updateAdminType} />}
      <Router>
        <Route path="/">
          <Home isAdmin={isAdmin} />
        </Route>
      </Router>
    </div>
  </LoadingOverlay>
    // </div>
  );
}

export default App;
